import { __generator } from "tslib";
import { put, call, takeEvery, select, takeLatest } from 'redux-saga/effects';
import { Url } from '@wix/da-url';
import { init, initDone, switchStream, streamLoadMore, initDoneAlready, initStreamDone, streamLoadDone, } from './actionCreators';
import { request } from '../../xhr';
import { EmoteStreamType } from './types';
import { isInitialized, getStream, getActiveStreamType, getSearchType, getSearchQuery, } from './selectors';
export function initHandler(action) {
    var initialized, result;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, select(isInitialized)];
            case 1:
                initialized = _a.sent();
                if (!initialized) return [3 /*break*/, 3];
                return [4 /*yield*/, put(initDoneAlready())];
            case 2:
                _a.sent();
                return [2 /*return*/];
            case 3: return [4 /*yield*/, call(request, {
                    method: 'get',
                    url: "/emotes/official",
                }, getFake('official'))];
            case 4:
                result = _a.sent();
                if (!(result && !result.error)) return [3 /*break*/, 6];
                return [4 /*yield*/, put(initDone(result))];
            case 5:
                _a.sent();
                _a.label = 6;
            case 6: return [2 /*return*/];
        }
    });
}
export function switchStreamHandler(action) {
    var requestedStream, searchType, stream, result;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                requestedStream = action.payload.streamType;
                searchType = action.payload.searchType;
                return [4 /*yield*/, select(function (state) { return getStream(state, requestedStream); })];
            case 1:
                stream = _a.sent();
                if (!(requestedStream !== EmoteStreamType.SEARCH &&
                    stream &&
                    stream.results.length > 0)) return [3 /*break*/, 3];
                return [4 /*yield*/, put(initStreamDone(requestedStream, null))];
            case 2:
                _a.sent();
                return [2 /*return*/];
            case 3: return [4 /*yield*/, call(request, {
                    method: 'get',
                    url: "/emotes/".concat(requestedStream),
                    params: {
                        offset: 0,
                        query: action.payload.searchQuery,
                        searchType: searchType,
                    },
                }, getFake(requestedStream))];
            case 4:
                result = _a.sent();
                if (!(result && !result.error)) return [3 /*break*/, 6];
                return [4 /*yield*/, put(initStreamDone(requestedStream, result))];
            case 5:
                _a.sent();
                _a.label = 6;
            case 6: return [2 /*return*/];
        }
    });
}
export function loadStreamHandler() {
    var activeStreamType, searchType, searchQuery, stream, result;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, select(getActiveStreamType)];
            case 1:
                activeStreamType = _a.sent();
                return [4 /*yield*/, select(getSearchType)];
            case 2:
                searchType = _a.sent();
                return [4 /*yield*/, select(getSearchQuery)];
            case 3:
                searchQuery = _a.sent();
                return [4 /*yield*/, select(function (state) { return getStream(state, activeStreamType); })];
            case 4:
                stream = _a.sent();
                if (!stream.hasMore) {
                    return [2 /*return*/];
                }
                return [4 /*yield*/, call(request, {
                        method: 'get',
                        url: "/emotes/".concat(activeStreamType),
                        params: {
                            offset: stream.nextOffset,
                            query: searchQuery,
                            searchType: searchType,
                        },
                    }, getFake(activeStreamType, stream.nextOffset, false))];
            case 5:
                result = _a.sent();
                if (!(result && !result.error)) return [3 /*break*/, 7];
                return [4 /*yield*/, put(streamLoadDone(activeStreamType, result))];
            case 6:
                _a.sent();
                _a.label = 7;
            case 7: return [2 /*return*/];
        }
    });
}
export default function saga() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, takeEvery(init, initHandler)];
            case 1:
                _a.sent();
                return [4 /*yield*/, takeLatest(switchStream, switchStreamHandler)];
            case 2:
                _a.sent();
                return [4 /*yield*/, takeLatest(streamLoadMore, loadStreamHandler)];
            case 3:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
// Testing stuff below
function getFake(type, offset, hasMore) {
    if (offset === void 0) { offset = 0; }
    if (hasMore === void 0) { hasMore = true; }
    return function (options) {
        // important removes from prod bundle
        if (process.env.NODE_ENV !== 'production') {
            if (window.doError) {
                return {
                    error: 'invalid_request',
                    errorDescription: 'Not logged in.',
                    status: 'error',
                };
            }
            if (type === 'official') {
                var official = [];
                // eslint-disable-next-line global-require
                var emotes = require('@wix/da-sample-data').officialEmotes;
                for (var k in emotes) {
                    official.push({
                        type: 'official',
                        src: Url.staticCDNLink("emoticons".concat(emotes[k].src)),
                        title: emotes[k].name,
                        width: emotes[k].width,
                        height: emotes[k].height,
                    });
                }
                return {
                    hasMore: false,
                    nextOffset: null,
                    results: official,
                };
            }
            if (type === 'community') {
                var official = [];
                // eslint-disable-next-line global-require
                var emotes = require('@wix/da-sample-data').officialEmotes;
                for (var k in emotes) {
                    official.push({
                        type: 'community',
                        src: "https://orig00.deviantart.net/cf50/f/2014/149/1/4/clapping_pony_icon___rainbow_blitz_by_travispony-d7k9ff7.gif",
                        title: emotes[k].name,
                        width: 50,
                        height: 50,
                    });
                }
                return {
                    hasMore: hasMore,
                    nextOffset: 50,
                    results: official.slice(0, 50),
                };
            }
            if (type === 'search') {
                var official = [];
                // eslint-disable-next-line global-require
                var emotes = require('@wix/da-sample-data').officialEmotes;
                for (var k in emotes) {
                    official.push({
                        type: 'community',
                        src: 'https://orig00.deviantart.net/5b63/f/2018/086/3/0/crying_lynn_by_lunaloudfan10-dc75d9y.gif',
                        title: emotes[k].name,
                        width: 50,
                        height: 50,
                    });
                }
                return {
                    hasMore: hasMore,
                    nextOffset: 50,
                    results: official.slice(0, 50),
                };
            }
            if (type === 'user') {
                var official = [];
                // eslint-disable-next-line global-require
                var userz = require('@wix/da-sample-data').users;
                for (var _i = 0, userz_1 = userz; _i < userz_1.length; _i++) {
                    var user = userz_1[_i];
                    official.push({
                        type: 'user',
                        src: user.usericon,
                        title: user.username,
                        url: Url.userLink(user.username),
                        width: 50,
                        height: 50,
                    });
                }
                return {
                    hasMore: hasMore,
                    nextOffset: 50,
                    results: official.slice(0, 50),
                };
            }
        }
    };
}
//# sourceMappingURL=saga.js.map